<div class="main">
    <div class="loading-shade" *ngIf="isLoading || isLoadingImages">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>
    <table mat-table *ngIf="wellheads.length" [dataSource]="wellheads" class="wellheads-table handover-data-table">

        <!-- Auxiliary headers -->

        <ng-container matColumnDef="first-column-header">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="top-connector-header">
            <mat-header-cell *matHeaderCellDef [attr.colspan]="3"> Conexión Superior </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="spacer-column-header">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="bottom-connector-header">
            <mat-header-cell *matHeaderCellDef [attr.colspan]="3"> Conexión Inferior </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="last-columns-header">
            <mat-header-cell *matHeaderCellDef [attr.colspan]="2"></mat-header-cell>
        </ng-container>

        <!-- Actual headers -->

        <ng-container matColumnDef="sectionNameId">
            <mat-header-cell *matHeaderCellDef> Nombre de Sección<br>de Cabezal </mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index">
                <mat-form-field>
                    <mat-select [disabled]="readOnlyContent" name="sectionNameId" [(ngModel)]="wellheads[i].sectionNameId" (selectionChange)="enableSaveButton(i)">
                        <mat-option *ngFor="let name of wellheadSectionNames" [value]="name.wellheadSectionNameId">
                            {{name.wellheadSectionNameName}}
                        </mat-option>
                    </mat-select>
                    <mat-hint class="alert">
                        Requerido
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="topHub">
            <mat-header-cell *matHeaderCellDef> Diámetro <br>Nominal [pulg] </mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index">
                <ng-container>{{wellhead.topHub}}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="topFlange">
            <mat-header-cell *matHeaderCellDef> RWP [psi] </mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index">
                <ng-container>{{wellhead.topFlange}}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="topConnectorTypeId">
            <mat-header-cell *matHeaderCellDef> Tipo </mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index">
                <mat-form-field>
                    <mat-select name="topConnectorTypeId" [disabled]="readOnlyContent" [(ngModel)]="wellheads[i].topConnectorTypeId" (selectionChange)="enableSaveButton(i)">
                        <mat-option *ngFor="let type of wellheadTopConnectorTypes" [value]="type.wellheadTopConnectorTypeId">
                            {{type.wellheadTopConnectorTypeName}}
                        </mat-option>
                    </mat-select>
                    <mat-hint class="alert">
                        Requerido
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="spacer">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="bottomHub">
            <mat-header-cell *matHeaderCellDef> Diámetro <br>Nominal [pulg] </mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index">
                <ng-container>{{wellhead.bottomHub}}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="bottomFlange">
            <mat-header-cell *matHeaderCellDef> RWP [psi] </mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index">
                <ng-container>{{wellhead.bottomFlange}}</ng-container>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="bottomConnectorTypeId">
            <mat-header-cell *matHeaderCellDef> Tipo </mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index">
                <mat-form-field>
                    <mat-select name="bottomConnectorTypeId" [disabled]="readOnlyContent" [(ngModel)]="wellheads[i].bottomConnectorTypeId" (selectionChange)="enableSaveButton(i)">
                        <mat-option *ngFor="let type of wellheadBottomConnectorTypes" [value]="type.wellheadBottomConnectorTypeId">
                            {{type.wellheadBottomConnectorTypeName}}
                        </mat-option>
                    </mat-select>
                    <mat-hint class="alert">
                        Requerido
                    </mat-hint>
                </mat-form-field>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="flangeManufacturer">
            <mat-header-cell *matHeaderCellDef> Fabricante </mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index">
                {{ wellhead.flangeManufacturer }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let wellhead; let i = index" [ngClass]="'mat-column-save'">
                <button mat-mini-fab (click)="openComments(wellheads[i], i, $event, readOnlyContent);" class="comment-ho-icon" name="openComments">
          <mat-icon class="material-icons-outlined">chat_bubble_outline</mat-icon>
          <div class="circle-comments" *ngIf="wellheads[i].comments"></div>
          <span class = "comment">Comentar</span>
        </button>
                <button mat-mini-fab (click)="save(wellheads[i], i);" class="save-ho-icon" [disabled]="isDisabled[i]" name="save">
          <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef colspan="10">
                <span>No existen registros de cabezal.</span>
            </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="['first-column-header', 'top-connector-header', 'spacer-column-header',
     'bottom-connector-header', 'last-columns-header']" class="auxiliary-header"></mat-header-row>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [ngClass]="{'hide-footer':hideFooter}"></mat-footer-row>
    </table>


    <div class="top" *ngIf="displayWellheadHydraulic">
        <h2>Prueba Hidráulica</h2>
        <form [formGroup] = "formHydraulic" (change) = "onChangeWellheadHydraulic()">
        <div class = "input-table">
            
                <div class = "input-column">
                    <mat-label>Válvula Maestra [psi]</mat-label>
                    <mat-form-field  >
                        <input matInput [readonly]="readOnlyContent" formControlName="masterValve" type="text" maxlength = "5">
                        <mat-hint class="alert" *ngIf="formHydraulic.get('masterValve')?.errors && formHydraulic.get('masterValve')?.hasError('pattern')">
                            Debe ser entero positivo.
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div class = "input-column">
                    <mat-label>Válvula Sobre Maestra [psi]</mat-label>
                    <mat-form-field>
                        <input matInput [readonly]="readOnlyContent" formControlName="valveOverMaster" type="text" maxlength = "5">
                        <mat-hint class="alert" *ngIf="formHydraulic.get('valveOverMaster')?.errors && formHydraulic.get('valveOverMaster')?.hasError('pattern')">
                            Debe ser entero positivo.
                        </mat-hint>
                    </mat-form-field>
                </div>
            
        </div>      
        <div class="wellhead-hydraulic-actions">
            <button mat-button class="save" title="Guardar" (click)="saveWellheadHydraulic()" [disabled]="formHydraulic.invalid || readOnlyContent">
                <mat-icon class="material-icons-outlined">save</mat-icon>Guardar
            </button>
        </div>  
        </form>
    </div>
     <!-- File Attachment -->
     <div class="handover-files" *ngIf="displayWellheadHydraulic">
        <div class="top">
            <h2>Adjuntar Prueba Hidráulica</h2>
            <div>
                <div *ngIf="wellheadAttachment == null">
                    0{{ "/" + fileLimit + " Archivos" }}
                  </div>
                  <div *ngIf="wellheadAttachment != null">
                    {{ wellheadAttachment?.length + "/" + fileLimit + " Archivos" }}
                  </div>
            </div>
            <ng-container *ngIf="wellheadAttachment?.length < fileLimit">
                <input
                  type="file"
                  class="file-input"
                  accept=".xls, .xlsx, .pdf, .jpg, .jpeg, .png, .gif"
                  (change)="onFileSelected($event)"
                  #fileUpload
                  style="display: none"
                />
                <div class="attach" title="Documento">
                    <button
                    mat-button
                    class = "upload-button"
                    (click)="fileUpload.click()"
                    [disabled]="readOnlyContent">
                    <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar archivo</button><br/>
                  <span>Archivos Excel, PDF e Imágenes</span>
                </div>
            </ng-container>
        </div>
        <div class="grid-attachment">
            <div class = "attachment" *ngFor="let f of wellheadAttachment">
                <a
                    class="attachment-link"
                    href="{{dhoApiUrl}}/{{ f?.file_path }}"
                    download="{{ f?.file_original_name }}"
                    target="_blank"
                >
                    {{ f?.file_original_name }}
                </a>
                <!-- Boton borrar-->
                <button
                    *ngIf="!readOnlyContent"
                    mat-button
                    class="delete-button"
                    (click)="deleteWellheadAttachment(f.file_id)"
                    [disabled]="readOnlyContent"
                >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="handover-images">
        <div class="top">
            
            <div class="footer" *ngIf="relatedHandover.isHoInEmitterSide">
                <div class="footer-no-data" *ngIf="!this.isHOLOC">Imágenes de Cabezal ya no es editable por usted.</div>
                <div class="footer-no-data-origin" *ngIf="!relatedHandover.isRelatedHoTaken" >
                  El {{relatedHandover.relatedHandoverTypeName}} creado el {{relatedHandover.creationDate | date: 'dd/MM/yyyy'}}, está siendo editado por el equipo {{this.isHOLOC ? 'Operativo': 'Company Man'}}.
                </div>
                <div class="footer-no-data-origin" *ngIf="relatedHandover.isRelatedHoTaken">
                  El {{relatedHandover.relatedHandoverTypeName}} creado el {{relatedHandover.creationDate | date: 'dd/MM/yyyy'}}, está siendo editado por {{relatedHandover.usernameEditor}}.</div>
            </div>

            <h2>Imágenes de Cabezal</h2>

            <div clas="count">{{wellheadImages.length + '/' + imageLimit + ' imágenes'}}
                <br />
                <mat-hint class="alert"   *ngIf="wellheadImages.length < qtyImageRequired && qtyImageRequired >= 2">
                Es obligatorio adjuntar al menos {{qtyImageRequired}} imágenes.</mat-hint
                >
                <mat-hint class="alert"   *ngIf="wellheadImages.length < qtyImageRequired && qtyImageRequired == 1">
                    Es obligatorio adjuntar al menos {{qtyImageRequired}} imagen.</mat-hint
                    >
        
            </div>

            <div class="attach" *ngIf="wellheadImages.length < imageLimit">
                <button mat-button [disabled]="readOnlyContent || !canUserEditImages || ReadOnlyContentWellheadImages" (click)="attachImage()">
          <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar foto o diagrama
        </button><br>
                <span>Archivos PNG, JPG están permitidos</span>
            </div>
        </div>

        <div class="grid">
            <div class="image" *ngFor="let image of wellheadImages.slice(0,3); index as i; first as isFirst">
                <div class="actions">
                    <div class="button">
                        <button mat-icon-button *ngIf="!readOnlyContent && canUserEditImages && !ReadOnlyContentWellheadImages" (click)="deleteImage(image, i)">
                            <mat-icon class="material-icons-outlined">delete</mat-icon>
                        </button> &nbsp;
                        <span class="legend" *ngIf="!readOnlyContent">Eliminar</span>
                    </div>
                    <div class="button">
                        <span class="legend">Ampliar</span>&nbsp;
                        <button mat-icon-button (click)="openImage(image)">
                            <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
                        </button>
                    </div>
                </div>
                <img src="{{dhoApiUrl}}/{{image.imagePath}}" alt="{{image.imageDescription}}" />
                <div class="description" *ngIf="image.imageDescription">
                    {{image.imageDescription}}
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="image" *ngFor="let image of wellheadImages.slice(3,6); index as i; first as isFirst">
                <div class="actions">
                    <div class="button">
                        <button mat-icon-button *ngIf="!readOnlyContent && canUserEditImages && ReadOnlyContentWellheadImages" (click)="deleteImage(image, i)">
                            <mat-icon class="material-icons-outlined">delete</mat-icon>
                        </button> &nbsp;
                        <span class="legend" *ngIf="!readOnlyContent">Eliminar</span>
                    </div>
                    <div class="button">
                        <span class="legend">Ampliar</span>&nbsp;
                        <button mat-icon-button (click)="openImage(image)">
                            <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
                        </button>
                    </div>
                </div>
                <img src="{{dhoApiUrl}}/{{image.imagePath}}" alt="{{image.imageDescription}}" />
                <div class="description" *ngIf="image.imageDescription">
                    {{image.imageDescription}}
                </div>
            </div>
        </div>
    </div>

    <app-handover-detail-wellhead-scheme
        [handover]="handover"
        [readOnlyContent]="readOnlyContent"
        (hasPendingChanges)="onSchemePendingChanges($event)">
    </app-handover-detail-wellhead-scheme>
</div>
